import { render, staticRenderFns } from "./BCOptionalFeaturesPasswordSettings.vue?vue&type=template&id=9d6ccad6&scoped=true"
import script from "./BCOptionalFeaturesPasswordSettings.vue?vue&type=script&lang=js"
export * from "./BCOptionalFeaturesPasswordSettings.vue?vue&type=script&lang=js"
import style0 from "./BCOptionalFeaturesPasswordSettings.vue?vue&type=style&index=0&id=9d6ccad6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d6ccad6",
  null
  
)

export default component.exports